import { CertificationStatusChipOrIcon } from '@tableau/data-catalog-client-components';
import React from 'react';

import { FavoriteToggle } from '~common/react/components/FavoriteToggle/FavoriteToggle';
import { CERTIFIED_INDICATOR_TYPE } from '~src/catalog/components/dataQuality/DataQualityType';
import { dataQualityIndicatorInfoToDataQualityIndicator } from '~src/catalog/models/IDataQualityIndicatorInfo';
import { PublishedConnections } from '~src/publishedConnection/resources/PublishedConnections';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';

import { doesTooltipNotHaveOwnerToDisplay } from '../../../app/spaces/Tooltips/Elements/Tooltip';
import { TooltipAnchor } from '../../../app/spaces/Tooltips/TooltipAnchor';
import { Messages } from '../../../codegen/Localize';
import { PublishedConnectionTooltip } from '../tooltips/PublishedConnectionTooltip';

const CertificationCardStyle: React.CSSProperties = {
  paddingTop: '3px',
  marginLeft: '-9px',
  marginRight: '-3px',
};

export class PublishedConnectionCard extends ContentCard {
  public render() {
    const contentUrl = getContentUrlForItem(this.props.content, this.props.urls);

    const imageUrl = PublishedConnections.getPublishedConnectionIconPath(this.props.content as ISpaceItemDetailInfo<'virtualConnection'>, true);

    const publishedConnection = this.props.content;

    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(this.props.content);
    const certifications = publishedConnection.dataQualityIndicators?.filter(i => i.type === CERTIFIED_INDICATOR_TYPE)[0] ?? null;

    const certificationComponent = certifications ? (
      <div data-tb-test-id='virtualConnection-card-certification' style={CertificationCardStyle}>
        <CertificationStatusChipOrIcon
          subjectArea={'VirtualConnection'}
          kind={'vizportal'}
          anchoredAsset={{
            assetName: this.props.content.name,
            assetType: 'VirtualConnection',
            assetUrl: () => contentUrl,
          }}
          anchoredCertifications={[dataQualityIndicatorInfoToDataQualityIndicator(certifications)]}
          iconOnly={true}
          urls={this.props.urls}
          linksDisabled={false}
        />
      </div>
    ) : null;

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          title={Messages.publishedConnectionTooltipTitle()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <Thumbnail
            defaultImageUrl={imageUrl}
            thumbnailImageUrl={this.props.content.thumbnailUrl}
            hoveredOrSelected={this.props.hoveredOrSelected}
            navigateUrl={contentUrl}
            useBase64EncodedImage={true}
            allowDragAndDrop={this.props.allowDragAndDrop}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          {certificationComponent}
          <span data-tb-test-id="publishedConnection-name" className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            {this.props.content.name}
          </span>
          {this.showFavoritesStar() && <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'virtualConnection' })}
              onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'virtualConnection' })}
            />
          </span>}
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return (
      <PublishedConnectionTooltip
        content={this.props.content}
        urls={this.props.urls}
        inProjectSpace={this.props.inProjectSpace}
      />
    );
  }
}
